import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUndo = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 16",
	width: 16,
	height: 16,
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "matrix(0.6666666666666666,0,0,0.6666666666666666,0,0)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M 0.75,0.748v7.5h7.5 ",
			stroke: "currentColor",
			fill: "none",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M 12,23.248c6.213,0.004,11.253-5.03,11.257-11.243c0.004-6.213-5.03-11.253-11.243-11.257 C7.243,0.745,2.99,3.751,1.4,8.248",
			stroke: "currentColor",
			fill: "none",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	})
});
export default SvgUndo;
